import { MuiThemeComponentsType } from '../types';

export default (): MuiThemeComponentsType['MuiSkeleton'] => ({
  styleOverrides: {
    root: {
      borderRadius: 10,
    },
  },
});
